export default __webpack_public_path__ + "static/media/checkoutLabel.3a29c769.jpg";